export default __webpack_public_path__ + "static/media/arrow-down-blue.d13b5084.svg";